var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"32a6f1823decbc5cd6fcf522a6ef456a41688843"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ecommerce-web-app@pod-point-ltd"]={id:"32a6f1823decbc5cd6fcf522a6ef456a41688843"};
      